{
  "longPressMessage": "Pressione e segure para abrir a visualização"
}
